import { defineSchema, SchemaInstance } from "../../type-system/schema";

/**
 * Fake because we don't save post purchase flow in the AdvancedFlow
 * collection, but necessary for frontend type system.
 */
export const basePostPurchaseSchema = defineSchema({ fields: {} });

export const examplebasePostPurchaseInstance: SchemaInstance<
  typeof basePostPurchaseSchema
> = {};

export function createbasePostPurchaseInstance(): SchemaInstance<
  typeof basePostPurchaseSchema
> {
  return {};
}
